import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tag, DatePicker, Button, Row, Popover, Tooltip } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import {
    cleanObject, stripHtml, isValidDate, renderPaymentMethod, renderMoney,
    paymentMethodOptions, PaymentType
} from '@/utils/helpers';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { exportCashBookExcel, getListCashBook } from '@/redux/actions/CashBookActions';
import { ExportOutlined, QuestionCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { fetchCustomer } from '@/redux/actions/customerActions';
import DynamicTable from '@/components/DynamicTable';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import { NotificationManager } from 'react-notifications';
import BaseSelect from '@/components/Elements/BaseSelect';
import { getBranchActive } from '@/redux/actions/branchActions';
import {
    depositScopeOptions,
    getDepositStatusLabel,
    getReceiptCollectionPurposeLabel,
    getReceiptCurrentContent,
    receiptCollectionPurposeOptions,
} from '@/utils/receiptCollectionResult';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/cash-book',
        breadcrumbName: 'Sổ quỹ',
    },
]
const { RangePicker } = DatePicker;

class CashBookList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenCustomerDetail: false,
            currentCustomerData: null,
            isLoadingExport: false,
        }
    }

    componentDidMount() {
        this.loadData();
        this.props.getBranchActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getListCashBook(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    loadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getListCashBook(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query.page = 1;
        if (name === 'payment_at') {
            if (value && value.length > 0) {
                query.payment_date_from = moment(value[0]).format('YYYY-MM-DD');
                query.payment_date_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.payment_date_from;
                delete query.payment_date_to;
            }
        }
        delete query.payment_at;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenCustomerDetail(isOpenCustomerDetail, data = null) {
        this.setState({ isOpenCustomerDetail: isOpenCustomerDetail, currentCustomerData: data });
    }

    onCustomerDetail(customer_id) {
        this.setState({ currentCustomerId: customer_id })
        this.props.fetchCustomer(customer_id).then(res => {
            this.toggleOpenCustomerDetail(true, res);
        })
    }

    startExcelExport() {
        const query = qs.parse(this.props.location.search.slice(1));
        delete query.page;
        delete query.per_page;

        this.setState({ isLoadingExport: true });
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. File kết quả sẽ được gửi vào email ${this.props.authUser?.email || 'đã cấu hình'} trong ít phút.`,
            'Thông báo',
            9000
        );

        this.props.exportCashBookExcel(query)
            .then(() => {
                NotificationManager.success(
                    'Đã xuất Sổ quỹ theo bộ lọc và gửi file qua email.',
                    'Hoàn tất',
                    9000
                );
            })
            .catch((error) => {
                NotificationManager.error(
                    error?.response?.data?.msg || 'Không thể xuất Sổ quỹ. Vui lòng thử lại sau.',
                    'Lỗi',
                    9000
                );
            })
            .finally(() => this.setState({ isLoadingExport: false }));
    }

    render() {
        var { branchActiveList, cash_book_list, pagination, summary } = this.props;
        var { isLoading, isLoadingExport, selectedRowKeys } = this.state;
        const hasSelected = selectedRowKeys.length > 0;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            {
                title: 'Mã phiếu',
                dataIndex: 'code',
                key: 'code',
                width: '100px'
            },
            {
                title: 'Ngày TT',
                dataIndex: 'payment_at',
                key: 'payment_at',
                width: '100px',
                render: (text, record) => {
                    if (text && text !== '') {
                        return (
                            <>{isValidDate(text, false)}</>
                        )
                    } else {
                        return (<Tag></Tag>)
                    }
                }
            },
            {
                title: 'Khách hàng',
                key: 'customer_name',
                width: 300,
                render: (_, record) => {
                    const customer = {
                        id: record?.customer_id,
                        code: record?.customer_code,
                        full_name: record?.customer_name,
                        branch_name: record?.branch_name,
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            enableLink={true}
                        />
                    )
                }
            },
            {
                title: 'Nội dung thu',
                dataIndex: 'items',
                key: 'items',
                width: '200px',
                render: (text, record) => {
                    if (record.collection_purpose === 'DEPOSIT') {
                        const depositInfo = record?.deposit_info || {};
                        return <div>
                            <TextTruncate
                                line={2}
                                truncateText="…"
                                text={getReceiptCurrentContent(record)}
                            />
                            {depositInfo.deposit_id && <div style={{ marginTop: 4, color: '#595959', fontSize: 12 }}>
                                Còn lại: <NumberFormat value={depositInfo.current_balance || 0} displayType="text" thousandSeparator />
                                {' · '}{getDepositStatusLabel(depositInfo.status)}
                            </div>}
                        </div>;
                    }
                    if (text && Array.isArray(text) && text.length) {
                        let content = text.map((item, index) => {
                            return (
                                <div style={{ padding: '5px 0' }}>
                                    {index + 1}. {item.name}
                                </div>
                            )
                        })
                        let first_item = text[0]?.name;
                        return (
                            <Popover placement="right" content={content}>
                                <div className='item-action-btn'>
                                    <TextTruncate line={1} truncateText="…" text={stripHtml(first_item)} />
                                </div>
                            </Popover>
                        )
                    } else {
                        return (<></>)
                    }
                }
            },
            {
                title: 'Nghiệp vụ thu',
                dataIndex: 'collection_purpose',
                key: 'collection_purpose',
                width: '180px',
                render: value => <Tag color={value === 'DEPOSIT' ? 'gold' : 'blue'}>
                    {getReceiptCollectionPurposeLabel(value)}
                </Tag>,
            },
            {
                title: 'Doanh số',
                dataIndex: 'customer_revenue',
                key: 'customer_revenue',
                render: (text, record) => (
                    <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                )
            },
            {
                title: 'TT gần nhất',
                dataIndex: 'amount_paid',
                key: 'amount_paid',
                render: (text, record) => (
                    <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                )
            },
            {
                title: 'Hình thức thu',
                key: 'payment_breakdowns',
                width: '220px',
                render: (_, record) => (record.payment_breakdowns || record.paymentBreakdowns || []).map(row => (
                    <div key={row.id || row.payment_method} style={{ marginBottom: 4 }}>
                        {renderPaymentMethod(row.payment_method)} <strong>{renderMoney(row.amount)}</strong>{' '}
                    </div>
                )),
            },
            {
                title: 'Tổng đã TT',
                dataIndex: 'total_amount_paid',
                key: 'total_amount_paid',
                render: (text) => (
                    <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                ),
            },
            {
                title: 'Công nợ',
                dataIndex: 'total_debt',
                key: 'total_debt',
                width: '200px',
                render: text => <NumberFormat value={Math.max(0, Number(text) || 0)} displayType={'text'} thousandSeparator={true} />
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Sổ quỹ" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên khách hàng"
                        filterColSpan={6}
                        activeFilter={
                            query.payment_method ||
                            query.collection_purpose ||
                            query.deposit_scope ||
                            query.payment_type ||
                            query.payment_date_from ||
                            query.payment_date_to
                        }
                        filters={[
                            <BaseSelect
                                options={paymentMethodOptions || []}
                                onChange={(value) => this.onChangeFilter('payment_method', value)}
                                defaultValue={query.payment_method || null}
                                placeholder="Hình thức thu"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={receiptCollectionPurposeOptions}
                                onChange={(value) => this.onChangeFilter('collection_purpose', value)}
                                defaultValue={query.collection_purpose || null}
                                placeholder="Nghiệp vụ thu"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={depositScopeOptions}
                                onChange={(value) => this.onChangeFilter('deposit_scope', value)}
                                defaultValue={query.deposit_scope || null}
                                placeholder="Loại cọc"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={PaymentType || []}
                                onChange={(value) => this.onChangeFilter('payment_type', value)}
                                defaultValue={query.payment_type || null}
                                placeholder="Lần thanh toán dịch vụ"
                                className="w-100"
                            />,
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày thu', 'đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('payment_at', value)}
                                defaultValue={[
                                    query.payment_date_from ? moment(query.payment_date_from, 'YYYY-MM-DD') : null,
                                    query.payment_date_to ? moment(query.payment_date_to, 'YYYY-MM-DD') : null,
                                ]}
                            />,
                        ]}
                    >
                        <DatePicker.MonthPicker
                            allowClear={true}
                            style={{ width: '160px' }}
                            className="table-button"
                            format="MM/YYYY"
                            placeholder="Chọn tháng"
                            onChange={(value) => this.onChangeFilter('month', value ? value.format("YYYY-MM") : null)}
                            defaultValue={query.month ? moment(query.month, 'YYYY-MM') : null}
                        />
                        <BaseSelect
                            options={branchActiveList || []}
                            optionValue="id"
                            optionLabel="name"
                            placeholder="Chọn cơ sở"
                            className="table-button"
                            style={{ width: '160px' }}
                            onChange={(value) => this.onChangeFilter('branch_id', value)}
                            defaultValue={query.branch_id ? parseInt(query.branch_id, 10) : null}
                        />
                        <Button
                            className="table-button"
                            icon={<ExportOutlined />}
                            loading={isLoadingExport}
                            onClick={() => this.startExcelExport()}
                        >
                            Xuất Excel
                        </Button>
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData()}>Refresh</Button>

                    </TableActionBar>
                    {
                        hasSelected ? <Row className="mb-2" align="middle">Đang chọn {selectedRowKeys.length} bản ghi </Row> : ''
                    }
                </div>

                <div className='has-custom-column-table-btn'>
                    <DynamicTable
                        rowKey="id"
                        dataSource={cash_book_list || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={false}
                        moduleKey="cash_book_list"
                        className='has-table-summary'
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                        title={() => (
                            <div style={{ textAlign: 'left', fontSize: 14 }}>
                                <span style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
                                    Tổng số tiền thu{' '}
                                    <Tooltip title="Là tổng số tiền thu trên toàn bộ dữ liệu theo bộ lọc hiện tại, không chỉ các bản ghi đang hiển thị trên trang.">
                                        <QuestionCircleOutlined style={{ color: '#8c8c8c', cursor: 'help', marginRight: 2 }} />
                                    </Tooltip>
                                    :{' '}
                                </span>
                                <strong style={{ fontSize: 18, color: '#1677ff' }}>
                                    <NumberFormat
                                        value={summary?.amount_paid || 0}
                                        displayType="text"
                                        thousandSeparator
                                        suffix="đ"
                                    />
                                </strong>
                            </div>
                        )}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        cash_book_list: state.CashBookReducer.cash_book_list,
        summary: state.CashBookReducer.summary,
        pagination: state.CashBookReducer.pagination,
        users: state.config.users,
        authUser: state.auth.authUser,
        branchActiveList: state.branchReducer.branchActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListCashBook: (filter) => dispatch(getListCashBook(filter)),
        exportCashBookExcel: (filter) => dispatch(exportCashBookExcel(filter)),
        fetchCustomer: (id) => dispatch(fetchCustomer(id)),
        getBranchActive: () => dispatch(getBranchActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CashBookList' })(CashBookList));

